// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Bgvg","topBottomGutter":"Layout_topBottomGutter__dOYu8"};